export default __webpack_public_path__ + "static/media/white-play.c5db9a07.svg";